export default {
  steps: {
    discount: 'Rabat',
    mobile_app: 'Mobilapp',
    business_info: 'Virksomhedsoplysninger',
    create_preview: 'Opret forhåndsvisning af kontrakt',
    preview: 'Forhåndsvis kontrakt',
    sign: 'Underskriv kontrakt',
  },
  buttons: {
    back: 'Tilbage',
    continue: 'Fortsæt',
  },
  agreement:
    'Skift til årlig anvender rabatten på {{discount}}% på din {{plan}}-plan. Din fakturering fortsætter månedligt med {{amount}} pr. måned med en bindingsperiode på {{months}} måneder.',
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    failed_to_switch: 'Kunne ikke skifte til årlig',
    switched_to_annual: 'Kontrakten er skiftet til årlig 👌',
  },
};
